module.exports = __webpack_public_path__ + "static/img/1.4efa932.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/championscity/1.png
// module id = 5dOs
// module chunks = 1